import { ViewType } from 'types/global'

export type ConfigItem = {
  key: string
  description: string
  isFixed: boolean
  isHidden: boolean
}

const allColumnConfig = [
  {
    key: 'leadName',
    description: 'lead_information_title',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadType',
    description: 'Lead Type',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'priority',
    description: 'Priority',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'status',
    description: 'status_lbl',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadInDate',
    description: 'Lead In date',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadOwner',
    description: 'Lead Owner',
    isFixed: false,
    isHidden: false,
  },
  {
    key: 'additionalOwner',
    description: 'Additional Owner',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'leadCampaign',
    description: 'Campaign, Source',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'totalMarketPotential',
    description: 'market_potential_title_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'lastActivity',
    description: 'Last Activity',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'lastActivityOutcome',
    description: 'last_activity_outcome',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'registrationNumber',
    description: 'reg_no_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'recycledDateAndValue',
    description: 'last_recycled_date_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'convertedDate',
    description: 'Converted Date',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'convertedBy',
    description: 'Converted By',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'closedDate',
    description: 'Closed Date',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'closedBy',
    description: 'Closed By',
    isFixed: false,
    isHidden: false,
  },
  {
    key: 'closedReason',
    description: 'Closed Reason',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'closedReasonDetails',
    description: 'Closed Reason Details',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'nextActivityDate',
    description: 'next_activity_date_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'totalCalls',
    description: 'total_calls_lbl',
    isFixed: false,
    isHidden: true,
  },
]

const openColumnConfig = [
  {
    key: 'leadName',
    description: 'lead_information_title',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadType',
    description: 'Lead Type',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'priority',
    description: 'Priority',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'status',
    description: 'status_lbl',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadInDate',
    description: 'Lead In date',
    isFixed: true,
    isHidden: false,
  },
  {
    key: 'leadOwner',
    description: 'Lead Owner',
    isFixed: false,
    isHidden: false,
  },
  {
    key: 'additionalOwner',
    description: 'Additional Owner',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'leadCampaign',
    description: 'Campaign, Source',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'totalMarketPotential',
    description: 'market_potential_title_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'lastActivity',
    description: 'Last Activity',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'lastActivityOutcome',
    description: 'last_activity_outcome',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'registrationNumber',
    description: 'reg_no_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'recycledDateAndValue',
    description: 'last_recycled_date_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'nextActivityDate',
    description: 'next_activity_date_lbl',
    isFixed: false,
    isHidden: true,
  },
  {
    key: 'totalCalls',
    description: 'total_calls_lbl',
    isFixed: false,
    isHidden: true,
  },
]

// This config could be moved to BE
export const columnConfig: { [key in ViewType]: Array<ConfigItem> } = {
  ALL: allColumnConfig,
  OPEN: openColumnConfig,
  CONVERTED: [
    {
      key: 'leadName',
      description: 'lead_information_title',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadType',
      description: 'Lead Type',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadInDate',
      description: 'Lead In date',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'convertedDate',
      description: 'Converted Date',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'convertedBy',
      description: 'Converted By',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadOwner',
      description: 'Lead Owner',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'additionalOwner',
      description: 'Additional Owner',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'leadCampaign',
      description: 'Source Campaign',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalMarketPotential',
      description: 'market_potential_title_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivity',
      description: 'Last Activity',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivityOutcome',
      description: 'last_activity_outcome',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'registrationNumber',
      description: 'reg_no_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'recycledDateAndValue',
      description: 'last_recycled_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'nextActivityDate',
      description: 'next_activity_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalCalls',
      description: 'total_calls_lbl',
      isFixed: false,
      isHidden: true,
    },
  ],
  INVALID: [
    {
      key: 'leadName',
      description: 'lead_information_title',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadType',
      description: 'Lead Type',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadInDate',
      description: 'Lead In date',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'closedDate',
      description: 'Closed Date',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'closedReason',
      description: 'Closed Reason',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'closedBy',
      description: 'Closed By',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'leadOwner',
      description: 'Lead Owner',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'additionalOwner',
      description: 'Additional Owner',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'leadCampaign',
      description: 'Source Campaign',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalMarketPotential',
      description: 'market_potential_title_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivity',
      description: 'Last Activity',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivityOutcome',
      description: 'last_activity_outcome',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'registrationNumber',
      description: 'reg_no_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'recycledDateAndValue',
      description: 'last_recycled_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'nextActivityDate',
      description: 'next_activity_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'closedReasonDetails',
      description: 'Closed Reason Details',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalCalls',
      description: 'total_calls_lbl',
      isFixed: false,
      isHidden: true,
    },
  ],
  LOST: [
    {
      key: 'leadName',
      description: 'lead_information_title',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadType',
      description: 'Lead Type',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadInDate',
      description: 'Lead In date',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'closedDate',
      description: 'Closed Date',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'closedReason',
      description: 'Closed Reason',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'closedBy',
      description: 'Closed By',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'leadOwner',
      description: 'Lead Owner',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'additionalOwner',
      description: 'Additional Owner',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'leadCampaign',
      description: 'Source Campaign',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalMarketPotential',
      description: 'market_potential_title_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivity',
      description: 'Last Activity',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivityOutcome',
      description: 'last_activity_outcome',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'registrationNumber',
      description: 'reg_no_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'recycledDateAndValue',
      description: 'last_recycled_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'nextActivityDate',
      description: 'next_activity_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'closedReasonDetails',
      description: 'Closed Reason Details',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalCalls',
      description: 'total_calls_lbl',
      isFixed: false,
      isHidden: true,
    },
  ],
  DELETED: [
    {
      key: 'leadName',
      description: 'lead_information_title',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadType',
      description: 'Lead Type',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'status',
      description: 'status_lbl',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'leadInDate',
      description: 'Lead In date',
      isFixed: true,
      isHidden: false,
    },
    {
      key: 'deletedDate',
      description: 'Deleted Date',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'deletedReason',
      description: 'Deleted reason',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'deletedBy',
      description: 'Deleted by',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'leadOwner',
      description: 'Lead Owner',
      isFixed: false,
      isHidden: false,
    },
    {
      key: 'closedDate',
      description: 'Closed Date',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'closedReason',
      description: 'Closed Reason',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'closedReasonDetails',
      description: 'Closed Reason Details',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'closedBy',
      description: 'Closed By',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'convertedDate',
      description: 'Converted Date',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'convertedBy',
      description: 'Converted By',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'additionalOwner',
      description: 'Additional Owner',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'leadCampaign',
      description: 'Campaign, Source',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalMarketPotential',
      description: 'market_potential_title_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivity',
      description: 'Last Activity',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'lastActivityOutcome',
      description: 'last_activity_outcome',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'registrationNumber',
      description: 'reg_no_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'recycledDateAndValue',
      description: 'last_recycled_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'nextActivityDate',
      description: 'next_activity_date_lbl',
      isFixed: false,
      isHidden: true,
    },
    {
      key: 'totalCalls',
      description: 'total_calls_lbl',
      isFixed: false,
      isHidden: true,
    },
  ],
}
